import React, { createContext, useContext, useEffect } from 'react';
import { useAppKitAccount } from '@reown/appkit/react';
import { useNavigate } from 'react-router';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const { isConnected } = useAppKitAccount();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isConnected) {
      navigate('/'); // Redirect to Home if not connected
    }
  }, [isConnected, navigate]);

  return (
    <AuthContext.Provider value={{ isConnected }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
